import { useThemeSlice } from "../ui/StatusBadge.jsx";
import { SkeletonBlock } from "./SkeletonBlock.jsx";
import { EntityTableBodySkeleton } from "./EntityTableBodySkeleton.jsx";

export function EntityTablePageSkeleton() {
  const { c } = useThemeSlice();

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <div style={{ padding: "18px 20px 12px", borderBottom: `1px solid ${c.divider}`, flexShrink: 0 }}>
        <SkeletonBlock width={140} height={22} style={{ marginBottom: 8 }} />
        <SkeletonBlock width={220} height={14} />
      </div>
      <div style={{ padding: "12px 20px", borderBottom: `1px solid ${c.divider}`, flexShrink: 0 }}>
        <SkeletonBlock width="100%" height={36} style={{ maxWidth: 320 }} />
      </div>
      <EntityTableBodySkeleton />
    </div>
  );
}
